import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LogoJargon from "../../../assets/images/logo-jargon.png";
import EffectSplatter from "../../../assets/images/effect-splatter.png";
import EffectSplatterWhite from "../../../assets/images/effect-splatter-white.png";

export default function Hero() {
    const { t } = useTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const raceDate = new Date("2026-06-07T06:00:00");
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const distance = raceDate - now;

            if (distance < 0) {
                clearInterval(interval);
                setCountdown({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setCountdown({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(interval);
    }, [raceDate]);
    return (
        <div className="w-full min-h-screen relative overflow-hidden">
            <div className="w-full bg-heroMobile md:bg-hero h-screen bg-no-repeat bg-cover bg-center text-white">
                <img
                    src={EffectSplatter}
                    alt=""
                    className="absolute top-[36rem] md:top-96 -right-[10rem] md:-right-[640px] md:96 md:w-[1536px] opacity-80 pointer-events-none z-1"
                />

                <img
                    src={EffectSplatterWhite}
                    alt=""
                    className="absolute top-24 md:top-20 -left-8 md:left-0 w-72 md:w-[80vh] opacity-80 pointer-events-none z-1"
                />
                <div className="hidden md:block container mx-auto w-full relative 2xl:top-36 md:top-0 top-48 2xl:px-0 md:px-24 z-10">
                    <div className="flex md:flex-row flex-col h-[50rem] items-center md:justify-between md:gap-y-0 gap-y-10">
                        <div className="md:w-1/2 flex justify-center items-center">
                            <img
                                src={LogoJargon}
                                alt="Suroboyo 10K Jargon Logo"
                                className="w-auto h-48 sm:h-64 md:h-80 2xl:h-96 object-contain"
                            />
                        </div>
                        <div className="md:w-1/2 md:px-0 px-10">
                            <div className="mt-3 flex items-center gap-8">
                                <p className="flex items-center gap-x-2 font-roboto font-bold text-xl md:text-2xl 2xl:text-4xl uppercase bg-primary px-4 py-2 mb-2">
                                    {t("hero.date")}
                                </p>
                            </div>
                            <div className="w-full rounded-lg">
                                <div className="grid grid-cols-4 text-center font-ronzino items-center 2xl:gap-y-10 gap-y-0">
                                    <div className="space-y-2 text-center">
                                        <div className="w-full h-full bg-bgHeroDays bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center 2xl:p-10 md:p-6 p-4">
                                            <h2 className="2xl:text-10xl md:text-8xl text-4xl font-wantCoffee text-primary text-center">
                                                {countdown.days}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-xs">DAYS</p>
                                    </div>
                                    <div className="space-y-2 text-center">
                                        <div className="w-full h-full bg-bgHeroHours bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center 2xl:p-10 md:p-6 p-4">
                                            <h2 className="2xl:text-10xl md:text-8xl text-4xl font-wantCoffee text-primary text-center">
                                                {countdown.hours}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-xs">HOURS</p>
                                    </div>
                                    <div className="space-y-2 text-center">
                                        <div className="w-full h-full bg-bgHeroMinutes bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center 2xl:p-10 md:p-6 p-4">
                                            <h2 className="2xl:text-10xl md:text-8xl text-4xl font-wantCoffee text-primary text-center">
                                                {countdown.minutes}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-xs">MINUTES</p>
                                    </div>
                                    <div className="space-y-2 text-center">
                                        <div className="w-full h-full bg-bgHeroSeconds bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center 2xl:p-10 md:p-6 p-4">
                                            <h2 className="2xl:text-10xl md:text-8xl text-4xl font-wantCoffee text-primary text-center">
                                                {countdown.seconds}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-xs">SECONDS</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="block md:hidden container mx-auto w-full relative 2xl:top-36 md:top-0 top-48 2xl:px-0 md:px-24 z-10">
                    <div className="flex md:flex-row flex-col h-[50rem] items-center md:justify-between md:gap-y-0 gap-y-10">
                        <div className="md:w-1/2 flex justify-center items-center">
                            <img
                                src={LogoJargon}
                                alt="Suroboyo 10K Jargon Logo"
                                className="w-auto h-36 object-contain"
                            />
                        </div>
                        <div className="px-0 w-[80vw]">
                            <div className="w-full rounded-lg">
                                <div className="grid grid-cols-2 text-center font-ronzino items-center gap-y-0">
                                    <div className="space-y-0 text-center">
                                        <div className="w-full h-full bg-bgHeroDays bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center p-4 min-h-36">
                                            <h2 className="text-7xl tabular-nums font-bold font-wantCoffee text-primary text-center">
                                                {countdown.days}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-md">DAYS</p>
                                    </div>
                                    <div className="space-y-0 text-center">
                                        <div className="w-full h-full bg-bgHeroHours bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center p-4 min-h-36">
                                            <h2 className="text-7xl tabular-nums font-bold font-wantCoffee text-primary text-center">
                                                {countdown.hours}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-md">HOURS</p>
                                    </div>
                                    <div className="space-y-0 text-center">
                                        <div className="w-full h-full bg-bgHeroMinutes bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center p-4 min-h-36">
                                            <h2 className="text-7xl tabular-nums font-bold font-wantCoffee text-primary text-center">
                                                {countdown.minutes}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-md">MINUTES</p>
                                    </div>
                                    <div className="space-y-0 text-center">
                                        <div className="w-full h-full bg-bgHeroSeconds bg-no-repeat bg-cover bg-center rounded-lg flex items-center justify-center p-4 min-h-36">
                                            <h2 className="text-7xl tabular-nums font-bold font-wantCoffee text-primary text-center">
                                                {countdown.seconds}
                                            </h2>
                                        </div>
                                        <p className="font-roboto font-bold 2xl:text-base text-md">SECONDS</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-8 flex justify-center items-center gap-8">
                                <p className="flex items-center gap-x-2 font-roboto font-bold text-xl md:text-2xl 2xl:text-4xl uppercase bg-primary px-3 py-1 mb-2">
                                    {t("hero.date")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
